/**
 * The UserEvent kinds this tool knows about. Mirrors UserEvents::Kinds.
 *
 * Its own module because both halves of the delivery path need it and neither
 * owns it: the service asks for events and consumes them, the hook polls for
 * them, and the service cannot import the hook.
 */
// eslint-disable-next-line import/prefer-default-export
export const BULK_IMPORT_COMPLETED = 'bulk_import_completed';
